import React from "react";
import { CalendarSettings, InputCallbacks, Profile } from "../model";

export interface CalendarContextValue {
    profile: Profile;
    calendarSettings: CalendarSettings;
    inputCallbacks: InputCallbacks;
}

const CalendarContext = React.createContext<CalendarContextValue | null>(null);

export default CalendarContext;
